/**
 * @prettier
 * @flow
 */
import { getLanguage } from 'src/utils/translate/language';

export function formatAsCurrency(number?: ?string): string {
    // TODO: Return maybe type
    if (!number) {
        return '';
    }
    const fractionDigits = number.includes('.') ? 2 : 0;
    return (
        Intl.NumberFormat(getLanguage(), {
            style: 'currency',
            currencyDisplay: 'symbol',
            currency: 'MXN',
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits,
        }).format((number: any)) + ' MXN'
    );
}
